var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"tips-container"},[_c('div',{staticClass:"tips-box"},[_c('p',[_vm._v("请在菜单中选择在浏览器中打开")]),_c('img',{attrs:{"src":require("../../assets/among/arrow.svg"),"alt":""}})]),_c('img',{attrs:{"src":require("../../assets/among/tips.png")}})])])])
}]

export { render, staticRenderFns }